import React from 'react';
import { useTheme } from '@/context/ThemeContext';

// CSS owns the web rotation: no per-frame JS or recursive completion callback
// survives when the composer stops or unmounts.
const css = `
@keyframes gab-composer-border-spin { to { transform: rotate(360deg); } }
.gab-composer-border-spin { animation: gab-composer-border-spin 1s linear infinite; }
@media (prefers-reduced-motion: reduce) { .gab-composer-border-spin { animation: none; } }
`;

export default function SpinningBorder() {
  const { colors } = useTheme();
  return <>
    <style>{css}</style>
    <div aria-hidden="true" className="gab-composer-border-spin" style={{
      pointerEvents: 'none', position: 'absolute', boxSizing: 'border-box',
      width: '100%', height: '100%', border: `2px solid ${colors.accent_text_color}`,
      borderRadius: 20, borderTopColor: 'transparent',
    }} />
  </>;
}
